import React from 'react';

const SvgHouse = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M12 2.1L1 12h3v9h6v-7h4v7h6v-9h3L12 2.1z" />
  </svg>
);

export default SvgHouse;
